import service from '../service.js'

export default {
    getPayslip(name){
      return service.get('payslip',{
            name : name
      })
    },
}